<!-- 种类列表    background-color="#2c3e50"-->
<template>
  <div class="nav">
    <div class="user">
      <div class="left"><img src="@/image/user.png" alt="" srcset="" style="width: 40px;height:40px" /></div>
      <div class="right">
        <div class="info">超级管理员</div>
        <div class="info-f">系统管理员</div>
      </div>
    </div>
    <div class="logo">
<!--      <img src="@/image/logo.png" alt srcset v-if="!isCollapse" style="width: 50px;" />-->
      <div v-if="!isCollapse" class="title">岚医全域医疗智能体</div>
      <img src="@/image/logo.png" alt srcset v-else style="width: 80px;" />
    </div>
    <!--
       TODO:
      hide可继续优化到store中去做映射，映射出2组数据，一组为权限设置全量的导航数据，一组为导航实际展示数据
      或 item.children.filter((j)=>{console.log(j); return j.hide}
    -->
    <el-menu
      :default-active="active"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      :collapse="isCollapse"
      :unique-opened="true"
      background-color="#4169e1"
      text-color="#fff"
      active-text-color="rgba(255,255,255,.2)"
    >
      <template v-for="item in navData">
        <!-- 一级导航 -->
        <el-menu-item
          :index="item.id"
          v-if="!item.children && !item.hide"
          :key="item.id"
          @click="itemBtn(item)"
        >
          <i :class="item.icon" style="color:#fff !important;"></i>
          <span slot="title">{{ item.label }}</span>
        </el-menu-item>
        <!-- 存在二级的一级导航 -->
        <el-submenu :index="item.id" :key="item.id + 1" v-if="item.children && !item.hide">
          <template slot="title">
            <!-- <i :class="item.icon"></i> -->
            <i :class="item.icon" style="color:#fff !important;"></i>
            <span slot="title">{{ item.label }}</span>
          </template>
          <!-- 二级 -->
          <div v-for="(item_next, index_next) in item.children" :key="index_next" style="">
            <el-menu-item
              :index="item_next.id"
              v-if="!item_next.children && !item_next.hide"
              @click="itemBtn(item_next)"
              
            >
              <span slot="title">{{ item_next.label }}</span>
            </el-menu-item>
            <!-- 三级 -->
            <!-- 存在三级的二级导航 -->
            <!-- <el-submenu :index="item_next.id" v-if="item_next.children && !item_next.hide">
              <span slot="title">{{ item_next.label }}</span>

              <el-menu-item v-for="(item_next_next, index_next_next) in item_next.children" :key="index_next_next"
                :index="item_next_next.id" @click="itemBtn(item_next_next)"
                v-if="!item_next.hide">{{ item_next_next.label }}</el-menu-item>
            </el-submenu>-->
            <el-submenu :index="item_next.id" v-else>
              <span slot="title">{{ item_next.label }}</span>
              <el-menu-item
                v-for="(item_next_next, index_next_next) in item_next.children"
                :key="index_next_next"
                :index="item_next_next.id"
                @click="itemBtn(item_next_next)"
              >{{ item_next_next.label }}</el-menu-item>
            </el-submenu>
          </div>
        </el-submenu>
      </template>
    </el-menu>
    <div class="menuZk" @click="collapseBtn"><i class="el-icon-s-fold"></i></div>
  </div>
</template>

<script>
import screenfull from "screenfull";
export default {
  name: "Nav",
  components: {},
  props: {
    isCollapse: {
      type: Boolean,
      default: true
    },
    navData: {
      type: Array
    },
    active: {
      type: String
    }
  },
  data() {
    return {};
  },
  methods: {
    //左侧菜单展开收起
    collapseBtn() {
      this.isCollapse = !this.isCollapse;  // 切换折叠状态
      this.$emit("collapse", this.isCollapse);  // 向父组件传递新状态
    },
    itemBtn(item, index) {
      this.$emit("clickNav", item, index);
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    }
  }
};
</script>

<style scoped lang="less">
.nav {
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  background: #4169e1;
  position: relative;

  .logo {
    // background: linear-gradient(to right, #12c2e9, #71ed7d);
    background: #4169e0;
    display: flex;
    align-items: center;
    color: #ffffff;
    font-weight: 550;
    justify-content: center;
    font-size: 14px;
    letter-spacing: 2px;
    height: 56px;
    margin-bottom: 1rem;
    img {
      width: 50px;
    }

    .title {
      font-size: 1.125rem;
      line-height: 1.75rem;
      font-weight: 600;
      height: 56px;
      display: flex;
      justify-content: center;
      align-items: center;
      letter-spacing: -1px;
    }
  }
  .user{
    display: flex;
    padding: 16px;
    height: 88px;
    align-items: center;
    .right{
      margin-left: 0.75rem;
      .info{
        font-weight: 500;
        font-size: 0.875rem;
        line-height: 1.25rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #fff;
      }
      .info-f{
        font-size: 0.75rem;
        line-height: 1rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color:rgba(255,255,255,.7);
      }
    }
  }
}

// .el-menu-vertical-demo:not(.el-menu--collapse) {
//   width: 200px;
//   min-height: 400px;
// }

.el-menu {
  background-color: #4169e0 !important;
  padding-left: 9px;
}
::v-deep .el-submenu__title{
  height: 40px !important;
  line-height: 40px !important;
}
::v-deep .el-submenu__title:hover{
  background: rgba(255,255,255,.1) !important;
  border-radius: 5px;
}
.el-menu .el-menu-item{
  height: 40px !important;
  line-height: 40px !important;
  border-radius: 5px;
  ::v-deep &::before{
    content: "";
    width: 10px;
    height: 10px;
    background:url("../../image/r-t-ico.png") no-repeat;
    position: absolute;
    right: 0;
    top:-10px;
    transition: opacity 0.3s ease;  /* 添加过渡动画 */
    display: block;  /* 保持元素存在 */
    opacity: 0;  /* 默认不可见 */
  }
  ::v-deep &::after{
    content: "";
    width: 10px;
    height: 10px;
    background:url("../../image/r-b-ico.png") no-repeat;
    position: absolute;
    right: 0;
    bottom:-10px;
    z-index: 2;
    transition: opacity 0.3s ease;  /* 添加过渡动画 */
    display: block;  /* 保持元素存在 */
    opacity: 0;  /* 默认不可见 */
  }
}
.el-menu .el-menu-item:hover{
  background:#5478e4 !important;
  ::v-deep &::before{
    opacity: 0!important;
  }
  ::v-deep &::after{
    opacity: 0!important;
  }
}
/* 菜单选中后的颜色 */
.el-menu .el-menu-item.is-active {
  background-color: #f3f4f7 !important;
  color: #4169e0 !important;
  border-radius: 10px 0 0 10px;
  &::before{
    opacity: 1;  /* 激活时渐显 */
  }
  &::after{
    opacity: 1;  /* 激活时渐显 */
  }
}

/* 点击二级菜单时多出的一像素边框问题 */
.el-submenu {
  background-color: #4169e0 !important;
}

.el-menu {
  border-right: none;
  background-color: #4169e0 !important;
}

// .el-menu-item {
//   background-color: #4169e0 !important;
// }

/* 子菜单hover颜色处理 */
// .el-menu-item:hover {
//    background-color: #f3f4f7 !important;
// }
::v-deep.el-submenu__title{
  line-height: 40px;
}
.menuZk{
  position: absolute;
  bottom: 40px;
  background: rgba(255,255,255,.2);
  border-radius: 5px 0 0 5px;
  right: 0;
  height: 40px;
  width: 40px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  i{
    font-size: 20px;
    color: #fff;
  }
}
</style>
